import get from 'lodash/get';
import Vue, { DirectiveOptions } from 'vue';
import { $http } from '../app.config';
import Questionnaire from '../components/Questionnaire.vue';
import { africaOptions, dataLayer } from '../globals';
import { EventBus } from '../helpers/bus';
import { uid, urlParam } from '../helpers/utils';
import store from '../store';

export interface QuestionnaireResult {
    answer: string | undefined;
    contact: boolean | undefined;
}

const show = (tId: string): void => {
    $http.get(africaOptions.api.routes.questionnaires.index + '/' + tId).then((response: any) => {
        const success = get(response, 'data.success', false);
        const { completed, content, options, pingBack, managerLogo } = get(response, 'data.body', {});
        if (!success || completed) {
            return;
        }
        const id = `questionnaire-${ uid() }`;
        let contacted: boolean = false; // Double sent protection
        let answered: QuestionnaireResult['answer'] | null = null; // Double sent protection
        EventBus.$on(id, ({ answer, contact }: QuestionnaireResult) => {
            if (answer && answer !== answered) {
                answered = answer;
                $http.put(`${ africaOptions.api.routes.questionnaires.index }/${ tId }`, { answer })
                    .then((res: any) => {
                        const score = get(res, 'data.body.revenueSalesConversionScore');
                        store.commit('orm/changeSalesScore', score);
                    });
            }
            const e = {
                eventAction: 'Questionnaire',
                eventLabel: answer,
                eventCategory: 'Enquire Form',
                event: 'questionnaire:submit',
            };
            if (!pingBack || contacted) {
                dataLayer.push(e);
                Vue.prototype.$modal.hide(id);
                return;
            }
            if (typeof contact === 'undefined') {
                return;
            }

            if (contact) {
                contacted = true;
                $http.post(`${ africaOptions.api.routes.questionnaires.contact }/${ tId }`);
            }

            if (answer) {
                dataLayer.push(e);
                Vue.prototype.$modal.hide(id);
            }
        });
        Vue.prototype.$modal.show(Questionnaire, {
            id,
            content,
            options,
            pingBack,
            managerLogo,
        }, {
            name: id,
            width: 960,
            height: 'auto',
            adaptive: true,
            scrollable: true,
            pivotY: 0.35,
            clickToClose: false,
        });
    });
};

const questionnaire: DirectiveOptions = {
    bind(): void {
        if (get(africaOptions, 'page.controller', 'page') !== 'page') {
            return;
        }
        if (!get(africaOptions, 'api.data.questionnaire.enabled', false)) {
            return;
        }
        // eslint-disable-next-line no-useless-escape
        if (window.location.href.match(new RegExp('\/request\/success-' + africaOptions.instance.locale + '\.htm')) === null) {
            return;
        }
        const tId = urlParam('tid', false);
        if (!tId) {
            return;
        }
        show(tId);
    },
};

export default questionnaire;
